export function inventoryReplenishmentNavigationBadge(count: number): string {
  const normalizedCount = Number.isFinite(count) ? Math.max(0, Math.trunc(count)) : 0;
  if (normalizedCount === 0) return "";
  return `<span class="inventory-replenishment-nav-badge" aria-label="補充依頼${normalizedCount}件">${normalizedCount}</span>`;
}
